'use strict'

/**
 * Base sliding effect mixin
 */
var BemCarouselSlider = function(carousel) {
	this.carousel = carousel
}

Object.assign(BemCarouselSlider.prototype, {
	init: function() {
		return this
	},
	slideTo: function(index) {
		var self = this
		this.carousel.$el.queue(function() {
			if (index == this.currentSlideIndex) {
				this.$el.dequeue()
				return false
			}

			this.beforeSlide(index)

			var $incomingSlide = this.$slides.eq(index)
			var $outgoingSlide = this.$currentSlide

			self.assignCurrentPillClass(index)
			self.assignCurrentSlideClass(index)

			$incomingSlide.addClass(this.elementClass('slide', 'incoming'))
			$outgoingSlide.addClass(this.elementClass('slide', 'outgoing'))

			this.$currentSlide = $incomingSlide
			this.currentSlideIndex = index

			setTimeout(function() {
				$incomingSlide.removeClass(this.elementClass('slide', 'incoming'))
				$outgoingSlide.removeClass(this.elementClass('slide', 'outgoing'))

				this.afterSlide(index)
				this.$el.dequeue()
			}.bind(this), this.slideDuration)
		}.bind(this.carousel))
	},
	assignCurrentPillClass: function(index) {
		this.carousel.$currentPill.removeClass(this.carousel.elementClass('pill', 'current'))
		this.carousel.$currentPill = this.carousel.$pills.eq(index)
		this.carousel.$currentPill.addClass(this.carousel.elementClass('pill', 'current'))
	},
	assignCurrentSlideClass: function(index) {
		var $incomingSlide = this.carousel.$slides.eq(index)
		var $outgoingSlide = this.carousel.$currentSlide
		$incomingSlide.addClass(this.carousel.elementClass('slide', 'current'))
		$outgoingSlide.removeClass(this.carousel.elementClass('slide', 'current'))
	},
	hasNext: function() {
		return this.carousel.cyclicScrolling || this.carousel.currentSlideIndex < this.carousel.$slides.length - 1
	},
	hasPrev: function() {
		return this.carousel.cyclicScrolling || this.carousel.currentSlideIndex > 0
	}
})

module.exports = BemCarouselSlider


/*****************
 ** WEBPACK FOOTER
 ** ./components/BemCarouselSlider.js
 ** module id = 164
 ** module chunks = 0
 **/